import { useTranslation } from 'react-i18next'
import { Plus, Sparkles } from 'lucide-react'
import { cn } from '@/shared/lib/utils'

interface NewProjectCardProps {
  onClick: () => void
  variant?: 'card' | 'hero'
}

export function NewProjectCard({ onClick, variant = 'card' }: NewProjectCardProps) {
  const { t } = useTranslation()

  if (variant === 'hero') {
    return (
      <div className="flex flex-col items-center gap-6 py-16">
        {/* NicolAI Icon */}
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-accent/10">
          <Sparkles className="h-10 w-10 text-accent" />
        </div>

        {/* Text */}
        <div className="flex flex-col items-center gap-2">
          <h2 className="text-xl font-semibold text-foreground">
            {t('dashboard.newProject.title')}
          </h2>
          <p className="max-w-[320px] text-center text-foreground-muted">
            {t('dashboard.newProject.description')}
          </p>
        </div>

        {/* CTA */}
        <button
          onClick={onClick}
          className={cn(
            'flex items-center gap-2 rounded-lg bg-accent px-6 py-3.5',
            'font-semibold text-white transition-colors hover:bg-accent-hover'
          )}
        >
          <Plus className="h-5 w-5" />
          {t('dashboard.newProject.cta')}
        </button>
      </div>
    )
  }

  return (
    <button
      onClick={onClick}
      className={cn(
        'group flex flex-col items-center justify-center gap-4 rounded-xl border-2 border-dashed border-border p-8',
        'transition-all hover:border-accent hover:bg-accent/5'
      )}
    >
      {/* Icon */}
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-accent/10 transition-colors group-hover:bg-accent/20">
        <Plus className="h-7 w-7 text-accent" />
      </div>

      {/* Text */}
      <div className="flex flex-col items-center gap-1">
        <span className="text-base font-semibold text-foreground">
          {t('dashboard.newProject.cardTitle')}
        </span>
        <span className="text-center text-sm text-foreground-muted">
          {t('dashboard.newProject.cardDescription')}
        </span>
      </div>
    </button>
  )
}
